var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderOutline20Old(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h3.382a2 2 0 011.789 1.106l.447.894H14a3 3 0 013 3v6a3 3 0 01-3 3H6a3 3 0 01-3-3V5zm5.382 0H5v9a1 1 0 001 1h8a1 1 0 001-1V8a1 1 0 00-1-1H9.382l-1-2z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDVDMyAzLjg5NTQzIDMuODk1NDMgMyA1IDNIOC4zODE5N0M5LjEzOTUxIDMgOS44MzIwNCAzLjQyOCAxMC4xNzA4IDQuMTA1NTdMMTAuNjE4IDVIMTRDMTUuNjU2OSA1IDE3IDYuMzQzMTUgMTcgOFYxNEMxNyAxNS42NTY5IDE1LjY1NjkgMTcgMTQgMTdINkM0LjM0MzE1IDE3IDMgMTUuNjU2OSAzIDE0VjVaTTguMzgxOTcgNUg1VjE0QzUgMTQuNTUyMyA1LjQ0NzcyIDE1IDYgMTVIMTRDMTQuNTUyMyAxNSAxNSAxNC41NTIzIDE1IDE0VjhDMTUgNy40NDc3MiAxNC41NTIzIDcgMTQgN0g5LjM4MTk3TDguMzgxOTcgNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgFolderOutline20Old as ReactComponent };